module.exports = __webpack_public_path__ + "img/logo.740b02c4.jpg";